import { ProfileField } from '@/pages/ProfileField'

type PostalContact = {
  address_line1?: string | null
  address_line2?: string | null
  city?: string | null
  region?: string | null
  postal_code?: string | null
  country?: string | null
  country_code?: string | null
}

export function ContactPostalAddressFields({ contact }: { contact: PostalContact }) {
  return (
    <>
      <ProfileField label="Address line 1" value={contact.address_line1 ?? '-'} />
      <ProfileField label="Address line 2" value={contact.address_line2 ?? '-'} />
      <ProfileField label="City" value={contact.city ?? '-'} />
      <ProfileField label="Region" value={contact.region ?? '-'} />
      <ProfileField label="Postcode" value={contact.postal_code ?? '-'} />
      <ProfileField label="Country" value={contact.country ?? contact.country_code ?? '-'} />
    </>
  )
}
